module.exports = __webpack_public_path__ + "img/dscvry_logo-purple.3364b5b5.png";